import React, { useState, useRef } from 'react';
import styles from './A_TextArea.module.css';
import cn from 'classnames';

interface A_TextAreaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  maxLength?: number;
  height?: number;
  background?: 'white' | 'gray';
  maxWidth?: string;
}

export default function A_TextArea({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  error,
  maxLength,
  height,
  background = 'white',
  maxWidth = '612px',
}: A_TextAreaProps) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const randomName = `field_${Math.random().toString(36).substr(2, 9)}`;

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (maxLength && newValue.length <= maxLength) {
      onChange(newValue);
    } else if (!maxLength) {
      onChange(newValue);
    }
  };

  const isActive = isFocused || value.length > 0;

  return (
    <div className={styles.wrapper} style={{ maxWidth }}>
      <div
        className={cn(styles.input_wrapper, styles[`background-${background}`])}
        style={{ height: height ? `${height}px` : 'auto' }}
      >
        <div className={styles.input_container}>
          <label
            className={cn(
              styles.label,
              isActive && styles.label_active,
              isActive ? 'text-p-8' : 'text-p-2'
            )}
            onClick={() => inputRef.current?.focus()}
          >
            {label}
          </label>
          <textarea
            ref={inputRef}
            name={randomName}
            value={value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}
            required={required}
            maxLength={maxLength}
            className={cn(
              styles.input,
              'text-p-2',
              error && styles.input_error
            )}
            autoComplete='new-password'
            autoCorrect='off'
            autoCapitalize='off'
            spellCheck='false'
            data-lpignore='true'
            data-form-type='other'
            data-1p-ignore
            data-bwignore
            placeholder=' '
          />

          {maxLength && (
            <span className={cn(styles.char_count, 'text-caption')}>
              {value.length}/{maxLength}
            </span>
          )}
        </div>
      </div>
      {error && (
        <span className={cn(styles.error, 'text-caption')}>{error}</span>
      )}
    </div>
  );
}
